import React from 'react';
import { TooltipProps } from 'recharts';
import { currencyFormatter } from 'utils/helpers/currencyFormatter';
import { CombinedChartData } from '../helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CustomTooltipProps = TooltipProps<any, any> & {
  categoryMap: CombinedChartData | null;
  currency: string;
};

const CustomTooltip2 = ({
  active,
  payload,
  label,
  categoryMap,
  currency,
}: CustomTooltipProps) => {
  if (!active || !payload || payload.length === 0) return null;

  const colorMap: Record<string, string> = {
    gcp_rev: '#4C8EE6',
    gcp_pipeline: '#93C5FD',
    psfdaf_rev: '#E75858',
    psfdaf_pipeline: '#FF9999',
  };

  //   const getLabel = () => {
  //     const { year } = categoryMap || {};
  //     const yearStr = `${
  //       year === String(new Date().getFullYear()) ? '' : `, ${String(year)}`
  //     }`;
  //     return `${label || ''}${yearStr || ''}`;
  //   };

  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ccc',
        padding: 10,
        borderRadius: 4,
        boxShadow: '0 0 5px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ fontWeight: 600, color: '#333', marginBottom: 6 }}>
        {label}
      </div>
      <div
        style={{
          color: colorMap.gcp_rev || '#000',
          fontSize: 13,
          lineHeight: '1.4',
        }}
      >
        GCP Revenue :{' '}
        {currencyFormatter(Number(categoryMap?.gcp_rev ?? 0), currency)}
      </div>
      <div
        style={{
          color: colorMap.gcp_pipeline || '#000',
          fontSize: 13,
          lineHeight: '1.4',
        }}
      >
        GCP Pipeline : {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        {currencyFormatter(Number(categoryMap?.gcp_pipeline ?? 0), currency)}
      </div>
      <div
        style={{
          color: colorMap.psfdaf_rev || '#000',
          fontSize: 13,
          lineHeight: '1.4',
        }}
      >
        PSF/DAF Services Revenue :{' '}
        {currencyFormatter(Number(categoryMap?.psfdaf_rev ?? 0), currency)}
      </div>
      <div
        style={{
          color: colorMap.psfdaf_pipeline || '#000',
          fontSize: 13,
          lineHeight: '1.4',
        }}
      >
        PSF/DAF Services Pipeline : {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        {currencyFormatter(Number(categoryMap?.psfdaf_pipeline ?? 0), currency)}
      </div>
    </div>
  );
};

export default CustomTooltip2;
